import * as Types from '../types/User';
import {PAGINATION} from '../../constants/define';
// import HotelRequest from "../mapping/Request/HotelRequest";

const initialState = {
    isFetching: false,
    all: [],
    errors: [],
    masterData: {},
    // item: new HotelRequest().update(),
    item: {},
    data: {
        result: [],
        page_size: PAGINATION.page_size,
        page_index: PAGINATION.page_index,
        total: PAGINATION.total,
        total_page: PAGINATION.total_page,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.USER_LIST_ACTION:
            return {...state, isFetching: true};
        case Types.USER_LIST_SUCCESS:
            return {...state, isFetching: false, data: action.users};
        case Types.USER_CREATE_ACTION:
            return {...state, isFetching: true};
        case Types.USER_CREATE_SUCCESS:
            return {...state, isFetching: false};
        case Types.USER_UPDATE_ACTION:
            return {...state, isFetching: true};
        case Types.USER_UPDATE_SUCCESS:
            return {...state, isFetching: false};
        case Types.USER_MASTER_DATA_ACTION:
            return {...state, isFetching: true};
        case Types.USER_MASTER_DATA_SUCCESS:
            return {...state, isFetching: false, masterData: action.masterData};
        case Types.USER_GET_TEM_ACTION:
            return {...state, isFetching: true};
        case Types.USER_GET_TEM_SUCCESS:
            return {...state, isFetching: false, item: action.item};
        case Types.USER_FAILED:
            return {...state, isFetching: false, errors: action.errors};
        case Types.USER_INIT:
            return initialState;
        default:
            return state;
    }
}
